module.exports = __webpack_public_path__ + "img/tms-side-panel-2-pl.52cb7d14.svg";